export const FeatureFlag = {
  AIAssessmentReview: 'aiAssessmentReview',
  CertificateDiscovery: 'certificateDiscovery',
  CertificateDiscoveryFull: 'certificateDiscoveryFull',
  ClientManagedAssessment: 'clientManagedAssessment',
  DisableAIAssessmentReview: 'disableAIAssessmentReview',
  DisableAIProfileSummary: 'disableAIProfileSummary',
  DisableBECalcFrameworkReqs: 'disableBECalcFrameworkReqs',
  ExternalMonitoringPaidClient: 'externalMonitoringPaidClient',
  ExternalMonitoringScanTypeDKIM: 'externalMonitoringScanTypeDKIM',
  FlexibleFramework: 'flexibleFramework',
  GatherExternalIntelligence: 'gatherExternalIntelligence',
  PolicyTemplates: 'policyTemplates',
  QuickAnswerModal: 'quickAnswerModal',
  ReviewRecaps: 'reviewRecaps',
  SignupOrgSurvey: 'signupOrgSurvey',
  SupplierContactSuggestion: 'supplierContactSuggestion',
  SupplierLastSignedIn: 'supplierLastSignedIn',
  SupplierProfileSummary: 'supplierProfileSummary',
  SupplierWeeklyDigest: 'supplierWeeklyDigest',
  ThreatsNotifications: 'threats_notifications',
  ToggleSupplierPrivateOnProfile: 'toggleSupplierPrivateOnProfile',
  ViewExternalIntelligence: 'viewExternalIntelligence',
  ViewExternalIntelligenceDebug: 'viewExternalIntelligenceDebug',
  ZeusBulkDiscussions: 'zeusBulkDiscussions',
} as const;

export type FeatureFlagValue = (typeof FeatureFlag)[keyof typeof FeatureFlag];
